import Backbone from 'backbone'

var LdapServer = Backbone.Model.extend()

export default LdapServer

LdapServer.__filename__ = 'admin/configuration/ldap-server-model.js'
